import { IFacetOption } from 'shared/types/ConstructorFacet';
import { SearchFilterConditionOptionDesktop } from 'search/components/searchGrid/SearchFilterConditionOptionDesktop';
import { UnorderedList } from 'shared/components/UnorderedList';

interface ISearchFilterConditionDesktop {
  facetType: string;
  filterOptions: Array<IFacetOption>;
  resultIds: Array<string>;
}

export const SearchFilterConditionDesktop = ({
  facetType,
  filterOptions,
  resultIds,
}: ISearchFilterConditionDesktop) => {
  return (
    <UnorderedList data-qa="search_filter_conditions_list">
      {filterOptions.map((option) => (
        <SearchFilterConditionOptionDesktop
          facetType={facetType}
          key={option.value}
          option={option}
          resultIds={resultIds}
        />
      ))}
    </UnorderedList>
  );
};
